import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import CategoryProduct from './CategoryProduct';
import NameProductForm from './NameProductForm';

const AddManuallyProductForm = ({
    defaultValues,
    onSubmit,
    children,
    isOpen,
    displayCategoryForm,
    setDisplayCategoryForm,
    selectedProduct,
    isCategory,
    cancelCloseModal,
}) => (
    <form onSubmit={onSubmit} noValidate>
        <NameProductForm
            defaultValues={defaultValues}
            isOpen={isOpen}
            setDisplayCategoryForm={setDisplayCategoryForm}
            selectedProduct={selectedProduct}
            style={!displayCategoryForm ? null : { display: 'none' }}
            isCategory={isCategory}
        />

        {displayCategoryForm && (
            <CategoryProduct
                setDisplayCategoryForm={setDisplayCategoryForm}
                selectedProduct={selectedProduct}
                displayCategoryForm={displayCategoryForm}
                defaultValues={defaultValues}
                groupedSubmit={onSubmit}
                matchWithSector={
                    !!selectedProduct?.monetaryRatioMatch || isCategory
                }
                isCategory={isCategory}
                cancelCloseModal={cancelCloseModal}
            />
        )}

        {children}
    </form>
);

AddManuallyProductForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
    displayCategoryForm: PropTypes.bool,
    setDisplayCategoryForm: PropTypes.func,
    cancelCloseModal: PropTypes.func,
    selectedProduct: PropTypes.string,
    isCategory: PropTypes.bool,
};

AddManuallyProductForm.defaultProps = {
    isOpen: true,
    displayCategoryForm: false,
    selectedProduct: '',
    isCategory: false,
};

export default withTranslation('common')(AddManuallyProductForm);
